/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import Treatment from '../../forms/treatment';
import UnitRadiologyService from '../../forms/unitRadiologyService';
import restApiClient from '../../services/restApiClient';
import FilterTree from '../../helpers/filterTree';
import { Hidden } from '@material-ui/core';
import AdornedTextField from '../adornedTextField';
import {
  Container,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  AddBox,
  StyledCrudTable,
  LocalHospital,
} from './styles';

const SelectTreatmentDialogControl = ({
  data,
  className,
  id,
  enabled,
  uischema,
  schema,
  path,
  label,
  handleChange,
  onSuccess,
  config,
  errors,
  visible,
  disabled,
  required,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const [selectedTreatment, setSelectedTreatment] = React.useState({});
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [orderBy, setOrderby] = useState({ id: 'asc' });
  const [searchBy, setSearchBy] = useState('');
  const columns = UnitRadiologyService.linkedServicesTableSchema;
  const unitId = config?.unitId;

  const handleClickOpen = () => {
    if (enabled) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    restApiClient.unitRadiologyService
      .getAllByUnit(
        unitId,
        rowsPerPage,
        page * rowsPerPage,
        searchBy
          ? new FilterTree()
              .like('treatment.name', searchBy)
              .or()
              .like('treatment.price', searchBy)
              .or()
              .like('treatment.origin.name', searchBy)
              .toString()
          : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  useEffect(() => {
    if (data) {
      restApiClient.treatment.findById(data).then((e) => {
        setSelectedTreatment(e.data);
      });
    } else {
      setSelectedTreatment({});
    }
  }, [data]);

  return (
    <Hidden xsUp={!visible}>
      <Container>
        <AdornedTextField
          disabled={!enabled}
          adornment={<LocalHospital />}
          clickableAdornment
          onAdornmentClick={handleClickOpen}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={handleClickOpen}
          label={label}
          InputLabelProps={{
            shrink: true,
            readOnly: true,
          }}
          value={selectedTreatment?.name ?? ''}
          required={required}
        />

        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={open}
          onClose={handleClose}
        >
          <DialogContent>
            <StyledCrudTable
              title={'Seleção de Tratamento'}
              modelActions={Treatment.actions}
              columns={columns}
              rows={rows}
              page={page}
              setPage={(page) => setPage(page)}
              rowsPerPage={rowsPerPage}
              availableRowsPerPage={[3]}
              setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
              onOrderByChange={(orderBy) => setOrderby(orderBy)}
              orderBy={orderBy}
              setOrderBy={(value) => setOrderby(value)}
              searchBy={searchBy}
              setSearchBy={(value) => setSearchBy(value)}
              actions={{
                insert: {
                  icon: <AddBox />,
                  onClick: (id, data) => {
                    setSelectedTreatment(data.treatment.id);
                    handleChange?.(path, data.treatment.id);
                    onSuccess?.(data.treatment.id);
                    handleClose();
                  },
                  title: 'Vincular',
                  allowedActions: [UnitRadiologyService.actions.getAllByUnit],
                },
              }}
              customCellRenderers={{
                'treatment.price': {
                  renderer: (field, value) => {
                    value = parseFloat(value);
                    return value.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    });
                  },
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <Button onClick={handleClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Hidden>
  );
};

export default SelectTreatmentDialogControl;
